import { render } from "./detail-info.vue?vue&type=template&id=63b3936a"
import script from "./detail-info.vue?vue&type=script&lang=js"
export * from "./detail-info.vue?vue&type=script&lang=js"

import "./detail-info.vue?vue&type=style&index=0&id=63b3936a&lang=scss"

import exportComponent from "/builds/feng.chen/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__